import React from "react";

function TargetPreview(props) {
  const [showMore, setShowMore] = React.useState(false);
  function getTrueProperties(obj) {
    if (obj) {
      let final_obj = {};
      Object.keys(obj).map((key, index) => {
        let value = obj[key];
        if (value === true || (Array.isArray(value) && value.length > 0)) {
          final_obj[key] = value;
        }
      });
      return final_obj;
    } else {
      return {};
    }
  }
  return (
    <>
      {Object.keys(getTrueProperties(props.data.target))?.map(
        (target, index) => {
          return (
            (index === 0 || showMore) && (
              <div className="w-full cd-mandals">
                <h6 className="capitalize" >{`Target ${target}`}</h6>
                <p className="">
                  {props.data.target[target].join(", ")}
                </p>
                {Object.keys(getTrueProperties(props.data.target)).length !==
                1 ? (
                  index === 0 && !showMore ? (
                    <button
                      onClick={() => setShowMore((prevState) => !prevState)}
                      className="btn-more-link text-blue-700 text-xs fw-bold hover:underline decoration-blue-700"
                    >
                      more
                    </button>
                  ) : index ===
                      Object.keys(getTrueProperties(props.data.target)).length -
                        1 && showMore ? (
                    <button
                      onClick={() => setShowMore((prevState) => !prevState)}
                      className="btn-more-link text-blue-700 text-xs fw-bold hover:underline decoration-blue-700"
                    >
                      less
                    </button>
                  ) : null
                ) : null}
              </div>
            )
          );
        }
      )}
    </>
  );
}

export default TargetPreview;
